import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Alert, Box, Button } from '@mui/material';
import React from 'react';
import { stringifyCsvFileToDataUrl } from '../CsvFile';
export function ImportResult(props) {
    const validate = props.type === 'validate';
    return (React.createElement(React.Fragment, null,
        props.afterImportMessage,
        !!props.validRowCount && (React.createElement(Alert, { severity: 'success' },
            validate ? 'Valid records' : 'Successfully imported',
            ": ",
            props.validRowCount)),
        !!props.errorRowCount && (React.createElement(Alert, { severity: 'error' },
            React.createElement("div", null,
                validate ? 'Invalid records' : 'Failed to import',
                ": ",
                props.errorRowCount),
            React.createElement("div", null, "Issues with these records include:"),
            React.createElement(Box, { component: 'ul', pl: 3, py: 1, pr: 0, m: 0 },
                props.uniqueErrors.map((error) => (React.createElement("li", { key: error }, error))),
                props.uniqueErrorsMoreCount != null && React.createElement("li", null,
                    "... and ",
                    props.uniqueErrorsMoreCount,
                    " more")))),
        !!props.warningRowCount && (React.createElement(Alert, { severity: 'warning' },
            React.createElement("div", null,
                validate ? 'Valid records with warnings' : 'Successfully imported with warnings',
                ": ",
                props.warningRowCount),
            React.createElement("div", null, "Issues with these records include:"),
            React.createElement(Box, { component: 'ul', pl: 3, py: 1, pr: 0, m: 0 },
                props.uniqueWarnings.map((warning) => (React.createElement("li", { key: warning }, warning))),
                props.uniqueWarningsMoreCount != null && React.createElement("li", null,
                    "... and ",
                    props.uniqueWarningsMoreCount,
                    " more")))),
        !!props.skippedRowCount && React.createElement(Alert, { severity: 'warning' },
            "Skipped records: ",
            props.skippedRowCount),
        (!!props.warningRowCount || !!props.errorRowCount || !!props.skippedRowCount) && (React.createElement(Box, { mt: 1 },
            React.createElement(Button, { "data-test": 'result-download-button', color: 'secondary', href: stringifyCsvFileToDataUrl(buildFileReportCsv(props.csvHeader, props.rows, props.type)), download: 'file_report.csv', target: '_blank', endIcon: React.createElement(CloudDownloadIcon, null) }, "Your file_report.csv")))));
}
export function calculateImportResult(type, csvHeader, rows) {
    const result = {
        type: type,
        validRowCount: 0,
        skippedRowCount: 0,
        warningRowCount: 0,
        uniqueWarnings: [],
        errorRowCount: 0,
        uniqueErrors: [],
        csvHeader: csvHeader,
        rows: rows,
    };
    for (const row of rows) {
        if (!row.errors.length) {
            if (!row.warnings.length) {
                if (row.object != null) {
                    result.validRowCount++;
                }
                else {
                    result.skippedRowCount++;
                }
            }
            else {
                result.warningRowCount++;
            }
        }
        else {
            result.errorRowCount++;
            for (const error of row.errors) {
                if (!result.uniqueErrors.includes(error)) {
                    result.uniqueErrors.push(error);
                }
            }
        }
        if (!!row.warnings.length) {
            for (const warning of row.warnings) {
                if (!result.uniqueWarnings.includes(warning)) {
                    result.uniqueWarnings.push(warning);
                }
            }
        }
    }
    if (result.uniqueWarnings.length > 5) {
        result.uniqueWarningsMoreCount = result.uniqueWarnings.length - 5;
        result.uniqueWarnings.splice(5);
    }
    if (result.uniqueErrors.length > 5) {
        result.uniqueErrorsMoreCount = result.uniqueErrors.length - 5;
        result.uniqueErrors.splice(5);
    }
    return result;
}
function buildFileReportCsv(csvHeader, rows, type) {
    return {
        header: [...csvHeader, 'Status', 'Message'],
        rows: rows.map((row) => mapFileReportCsvRow(row, type)),
    };
}
function mapFileReportCsvRow(row, type) {
    let status;
    const messages = [];
    if (row.errors.length > 0) {
        status = 'Error';
        for (const error of row.errors) {
            messages.push('Error: ' + error);
        }
    }
    if (row.object == null) {
        status !== null && status !== void 0 ? status : (status = 'Skipped');
    }
    if (row.warnings.length > 0) {
        status !== null && status !== void 0 ? status : (status = 'Warning');
        for (const warning of row.warnings) {
            messages.push('Warning: ' + warning);
        }
    }
    status !== null && status !== void 0 ? status : (status = type === 'import' ? 'Success' : '');
    return [...row.data, status, messages.join('. ')];
}
